module.exports = __webpack_public_path__ + "static/calle05-468e893d4f3adc7093d68c9a9605fc4d.jpg";